import React, { Component } from "react";
import style from "./InvoiceDetails.module.css";
import { Button } from "reactstrap";
import { connect } from "react-redux";
import moment from "moment";
import ReactToPrint from "react-to-print";
import { fetchInvoiceDetails, fetchpractitioner } from "../../../redux";
import api from "../../../utils/Api";
import ttmLoader from "../../../assets/images/ttm-loader.gif";
import techtToMed from "../../../assets/images/techtomedix-logo.png";
import { checkIfPermitted, Permissions } from "../../../services/RolePermissionService";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import * as Yup from "yup";
import { Formik, Field, Form, ErrorMessage } from "formik";
import { dateFormatter, formatNumberToCurrency, getValueOfPercent} from "../../../utils/CommonUtil";

export class InvoiceDetails extends Component {
  constructor(props) {
    super(props);

    this.state = {
      invoice_id: "",
      invoice_number: "",
      date: "",
      successMessage: "",
      errorMessage: "",
      isLoading: false,
      isScreenLoaded: false,
      isEstimate: 0,
      isModalOpen: false,
      shareEmail: ""
    };
  }

  componentDidMount = async () => {
    let path = this.props.location.pathname;
    if (path.includes("/app/estimatedetails")) {
      this.setState({
        isEstimate: 1
      })
      document.title = 'Estimate Details - TechToMedix';
    } else {
      document.title = 'Invoice Details - TechToMedix';
    }
    // Calling practitioner autocomplete data
    this.props.fetchpractitioner("");
    // Read history data
    if (this.props.location.state) {
      console.log("@@@@@@@@@@", this.props.location.state);
      this.setState(
        {
          invoice_id: this.props.location.state.invoice_id,
        }, async () => {
          console.log("***dfds*****", this.state.invoice_id);
          await this.props.fetchInvoiceDetails(this.state.invoice_id);
        }
      );
    }
    // Read url parameters
    if (this.props.match.params.id) {
      this.setState({
        invoice_id: this.props.match.params.id,
      });
      await this.props.fetchInvoiceDetails(this.props.match.params.id);
    }
    setTimeout(() => {
      this.setState({
        isScreenLoaded: true,
      });
    }, 500);
  }

  // API calls for download invoice details
  DownloadInvoice = async () => {
    this.setState({
      isLoading: true,
    });
    // headers
    const headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
      Accept: "application/pdf",
    };

    const payload = {
      invoice_id: this.state.invoice_id,
    };

    try {
      const response = await api.post("payment/invoice/download", payload, {
        headers: headers,
        responseType: "blob",
      });

      if (response.status === 200) {

        let message = "Invoice downloaded successfully";
        if(this.state.isEstimate === 1){
          message= "Estimate downloaded successfully"
        }
        this.setState({
          isLoading: false,
          successMessage: message,
        });

        let invoiceNumber = this.props.invoiceDetailsData.invoiceDetails &&
      this.props.invoiceDetailsData.invoiceDetails.invoice && 
      this.props.invoiceDetailsData.invoiceDetails.invoice.invoice_number ;
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        let pdfname = "Invoice";
        if(this.state.isEstimate === 1){
          pdfname= "Estimate"
        }
        let name =  pdfname+"-" + invoiceNumber + ".pdf";
        link.setAttribute("download", name);
        document.body.appendChild(link);
        link.click();

        setTimeout(() => {
          this.setState({
            successMessage: "",
          });
        }, 2000);
      }
    } catch (error) {
      console.log("Error in download", error);
      this.setState({
        isLoading: false,
        errorMessage: "Error in downloading pdf",
      });
      setTimeout(() => {
        this.setState({
          errorMessage: "",
        });
      }, 2000);
    }
  };

  //Share via email
  shareViaEmail = async () => {
    this.setState({
      isLoading: true,
      isModalOpen: false
    });
    // headers
    const headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
    };
    const payload = {
      invoice_id: this.state.invoice_id,
      email: this.state.shareEmail
    };

    try {
      const response = await api.post(
        "payment/invoice/shareViaEmail",
        payload,
        {
          headers: headers,
        }
      );

      if (response.status === 200) {
        this.setState({
          isLoading: false,
          successMessage: "Email sent successfully!",
        });

        setTimeout(() => {
          this.setState({
            successMessage: "",
          });
        }, 2000);
      }
    } catch (error) {
      console.log("Error in share via email payment", error);
      this.setState({
        isLoading: false,
        errorMessage: "Error in email sent",
      });
      setTimeout(() => {
        this.setState({
          errorMessage: "",
        });
      }, 2000);
    }
  };


  recievePayment = () => {
    
    let invoiceData = this.props.invoiceDetailsData.invoiceDetails &&
      this.props.invoiceDetailsData.invoiceDetails.invoice;
      this.props.history.push({
        pathname: "/app/receivepayment",
        state: {
          patient_id: invoiceData && invoiceData.associated_related_party_id,
          practitioner_id: invoiceData && invoiceData.requested_related_party_id,
          appointment_id: invoiceData && invoiceData.appointment_id,
          conductappointment_id: invoiceData && invoiceData.conductappointment_id,
          invoice_id: invoiceData && invoiceData.invoice_id,
          amount: Math.sign(invoiceData && invoiceData.balance) === 1 ? Number(invoiceData && invoiceData.balance) : 0
        },
      });
  }

  makePayment = () => {

    const data = this.props.invoiceDetailsData.invoiceDetails &&
    this.props.invoiceDetailsData.invoiceDetails.invoice;

    this.props.history.push({
        pathname: "/app/sendpayment",
        state: {
            patient_id: data && data.associated_related_party_id ? data.associated_related_party_id : "",
            practitioner_id: data && data.requested_related_party_id ? data.requested_related_party_id : "",
            isAppointmentPay: true,
            //mediswitchTransactionId: this.props.match.params.id,
            appointment_id: data &&  data.appointment_id ? data.appointment_id : "",
            invoice_id: data &&  data.invoice_id? data.invoice_id: "",
            amount: data && Math.sign(data && data.balance) === -1 ? -Number(data.balance) : 0
        },
    });
}

  goToAppointment = (appointment_id) => {
    this.props.history.push({
      pathname: "/app/createappointment/" + appointment_id
    })
  }

  getTitleName = (titleId) => {
    let dropdownData = this.props.dropdownListData.dropdownList;
    let prefix = dropdownData && dropdownData.prefix && dropdownData.prefix.find((item) => item.prefix_id === parseInt(titleId));
    return prefix && prefix.prefix_name ? prefix.prefix_name : "";
  }

  getBillingPolicy = (id) => {
    let dropdownData = this.props.dropdownListData.dropdownList;
    let billingPolicy = dropdownData && dropdownData.billing_policy &&
      dropdownData.billing_policy.find((item) => item.billing_policy_id === parseInt(id));
    return billingPolicy && billingPolicy.billing_policy ? billingPolicy.billing_policy : "Not Available";
  }

  getTreatmentPlace = (id) => {
    let dropdownData = this.props.dropdownListData.dropdownList;
    let lk_place_of_treatement = dropdownData && dropdownData.lk_place_of_treatement &&
      dropdownData.lk_place_of_treatement.find((item) => item.lk_place_of_treatement_id === id);
    return lk_place_of_treatement && lk_place_of_treatement.place ?
      lk_place_of_treatement.place : "Not Available";
  }

  getPractitionerName = (id) => {
    const practitionerOptions =
      this.props.practitionerData && this.props.practitionerData.practitioner;

    let practitioner = practitionerOptions &&
      practitionerOptions.find((item) => item.practitioner_id === Number(id));
    return practitioner && practitioner.practitioner_name ? practitioner.practitioner_name : "Not Available";
  }
  getInvoiceType = (id) => {
    let dropdownData = this.props.dropdownListData.dropdownList;
    let invoice_type = dropdownData && dropdownData.lk_invoice_type &&
      dropdownData.lk_invoice_type.find((item) => item.lk_invoice_type_id === id);
    return invoice_type && invoice_type.invoice_type ?
      invoice_type.invoice_type : "Not Available";
  }

  detailFormatter = (data) => {
    if (!data) {
      return "Not Available";
    } else {
      return data ? (data.charAt(0).toUpperCase() + data.slice(1)) : "Not Available";
    }
  }

  checkValidData = (data) => {
    if (!data) {
      return "Not Available";
    } else {
      return data;
    }
  }
  checkValidPrice = (data) => {
    if (data) {
      data = Number(data);
      return data !== "NaN" ? data.toFixed(2) : "0.00";
    } else {
      return "0.00";
    }
  }

   // toggle a modal
   toggle = (val) => {

    let email = 
    this.props.invoiceDetailsData.invoiceDetails.patientDetails &&
    this.props.invoiceDetailsData.invoiceDetails.patientDetails.email;

    this.setState((prevState) => ({
        isModalOpen: !prevState.isModalOpen,
        shareEmail: prevState.isModalOpen === false ? email: this.state.shareEmail,
    }));
}

handleChange = (event) => {
let name = event.target.name;
let val = event.target.value;

this.setState({
  [name]: val
})


}

  render() {
    // console.log(
    //   "********* Invoice details in component",
    //   this.props.invoiceDetailsData.invoiceDetails
    // );

    let invoiceData = this.props.invoiceDetailsData.invoiceDetails &&
      this.props.invoiceDetailsData.invoiceDetails.invoice;

      let billingPolicyConfiguration = this.props.invoiceDetailsData.invoiceDetails &&
      this.props.invoiceDetailsData.invoiceDetails.billingPolicyConfiguration;

      let billingPractitionerDetails = this.props.invoiceDetailsData.invoiceDetails &&
      this.props.invoiceDetailsData.invoiceDetails.billingPractitionerDetails;

      let patientDetails = this.props.invoiceDetailsData.invoiceDetails &&
      this.props.invoiceDetailsData.invoiceDetails.patientDetails;

    let responseData = this.props.invoiceDetailsData.invoiceDetails;

    let invoice_number =
      this.props.invoiceDetailsData.invoiceDetails.invoice &&
      this.props.invoiceDetailsData.invoiceDetails.invoice.invoice_number;

    let invoice_date =
      this.props.invoiceDetailsData.invoiceDetails.invoice &&
      this.props.invoiceDetailsData.invoiceDetails.invoice.invoice_date;

    let bill_to =
      this.props.invoiceDetailsData.invoiceDetails.invoice &&
      this.props.invoiceDetailsData.invoiceDetails.invoice.billTo;

    let billing_address =
      this.props.invoiceDetailsData.invoiceDetails.invoice &&
      this.props.invoiceDetailsData.invoiceDetails.invoice.billing_address;

    let patient_name =
      this.props.invoiceDetailsData.invoiceDetails.patientDetails &&
      (this.props.invoiceDetailsData.invoiceDetails.patientDetails.name + " " +
        this.props.invoiceDetailsData.invoiceDetails.patientDetails.surname);

    let patient_contact =
      this.props.invoiceDetailsData.invoiceDetails.patientDetails &&
      this.props.invoiceDetailsData.invoiceDetails.patientDetails.contact_number;

    let patient_email =
        this.props.invoiceDetailsData.invoiceDetails.patientDetails &&
        this.props.invoiceDetailsData.invoiceDetails.patientDetails.email;

    let patient_address =
      this.props.invoiceDetailsData.invoiceDetails.patientDetails &&
      this.props.invoiceDetailsData.invoiceDetails.patientDetails.physical_address;

    let sub_total =
      this.props.invoiceDetailsData.invoiceDetails.invoice &&
      this.props.invoiceDetailsData.invoiceDetails.invoice.sub_total;

    let vat_percent =
      this.props.invoiceDetailsData.invoiceDetails.invoice &&
      this.props.invoiceDetailsData.invoiceDetails.invoice.vat_percent;

    let vat_amount =
      this.props.invoiceDetailsData.invoiceDetails.invoice &&
      this.props.invoiceDetailsData.invoiceDetails.invoice.vat_amount;

    let total =
      this.props.invoiceDetailsData.invoiceDetails.invoice &&
      this.props.invoiceDetailsData.invoiceDetails.invoice.total;


    let doctorDetails =
      this.props.invoiceDetailsData.invoiceDetails &&
      this.props.invoiceDetailsData.invoiceDetails.doctorDetails;

    let doctor_name =
      this.props.invoiceDetailsData.invoiceDetails.doctorDetails &&
      this.getTitleName(this.props.invoiceDetailsData.invoiceDetails.doctorDetails.title) +
      " " +
      this.props.invoiceDetailsData.invoiceDetails.doctorDetails.name +
      " " +
      this.props.invoiceDetailsData.invoiceDetails.doctorDetails.surname;

    let doctor_contact =
      this.props.invoiceDetailsData.invoiceDetails.doctorDetails &&
      this.props.invoiceDetailsData.invoiceDetails.doctorDetails.contact_number;

    let doctor_email =
      this.props.invoiceDetailsData.invoiceDetails.doctorDetails &&
      this.props.invoiceDetailsData.invoiceDetails.doctorDetails.email;

    let physical_address =
      this.props.invoiceDetailsData.invoiceDetails.doctorDetails &&
      this.props.invoiceDetailsData.invoiceDetails.doctorDetails
        .physical_address;

    const treatementDetail = this.props.invoiceDetailsData.invoiceDetails.treatementDetail;

    const inventory =
      this.props.invoiceDetailsData.invoiceDetails &&
      this.props.invoiceDetailsData.invoiceDetails.inventory;

    let notes =
      this.props.invoiceDetailsData.invoiceDetails &&
      this.props.invoiceDetailsData.invoiceDetails.notes;

      const practice_logo = this.props.invoiceDetailsData.invoiceDetails &&
      this.props.invoiceDetailsData.invoiceDetails.practice_logo;

    if (!this.state.isScreenLoaded) {
      return (
        <div className="dashboard-loader">
          <img src={ttmLoader} alt="loader" className="loader-image" />
        </div>
      );
    }

    return (
      <div className={style.invoiceDetailsWrapper}>
        <div ref={(el) => (this.componentInvoiceRef = el)}>
          <div className="row d-print-block d-none">
            {/* <div className="col-12 mb-4 text-center print-logo">
              <img src={techtToMed} alt="TechToMed" />
              <h1>TechToMed</h1>
            </div> */}
            <div class="col-md-12">
              <div class="logo-header d-print-flex flex-row justify-content-center ">
                <div class="print-logo text-center ">
                  <img src={practice_logo} class="print-practice-logo" alt="TechToMed" />
                </div>
                {/* <div class="practice-details ml-auto">
                  <p>Company Name</p>
                  <p>Company Address</p>
                </div> */}
              </div>
            </div>


          </div>
          <div className="row">
            <div className="col-lg-12">
              <h3>{this.state.isEstimate === 0 ? "Invoice" : "Estimate"} - {invoice_number}</h3>
            </div>
          </div>
          <div className="form-box-shadow">
            <div className="row">
              <div className="col-lg-12">
                <div className={style.heading}>
                  <p>{this.state.isEstimate === 0 ? "Invoice" : "Estimation"}</p>
                </div>
              </div>

              <div className="col-lg-12">
                <div className="row">
                  <div className="col-md-6 col-xl-5 col-print-6">
                    {invoiceData && invoiceData.invoice_list_type !== 3 && (
                      <React.Fragment>
                        <div className="row">
                          <div className="col-md-8">
                            <h6 className="mb-2">{billingPractitionerDetails && billingPractitionerDetails.registration_name}</h6>
                            <p className="mb-2">{billingPractitionerDetails && billingPractitionerDetails.physical_address}</p>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-12">
                            <div className="row">
                              <div className="col-md-6 col-print-6"><label>Practice Contact No.:</label></div>
                              <div className="col-md-6 col-print-6">{billingPractitionerDetails && billingPractitionerDetails.contact_number}</div>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-12">
                            <div className="row">
                              <div className="col-md-6 col-print-6"><label>Practice PCNS No.:</label></div>
                              <div className="col-md-6 col-print-6">{billingPractitionerDetails && billingPractitionerDetails.billing_practise_pcns_number}</div>
                            </div>
                          </div>
                        </div>
                      </React.Fragment>)}
                  </div>
                  <div className="col-md-6 col-xl-4 offset-xl-3 col-print-6">
                    <div className="row">
                      <div className="col-md-6 col-print-6"><label>{this.state.isEstimate === 0 ? "Invoice" : "Estimate"} Number:</label></div>
                      <div className="col-md-6 col-print-6">{invoice_number}</div>
                    </div>
                    <div className="row">
                      <div className="col-md-6 col-print-6"><label>{this.state.isEstimate === 0 ? "Invoice" : "Estimate"} Type:</label></div>
                      <div className="col-md-6 col-print-6">{this.getInvoiceType(invoiceData && invoiceData.invoice_type_id)}</div>
                    </div>
                    <div className="row">
                      <div className="col-md-6 col-print-6"><label>{this.state.isEstimate === 0 ? "Invoice" : "Estimate"} Date:</label></div>
                      <div className="col-md-6 col-print-6">{ invoiceData && this.checkValidData(invoiceData.invoice_date)}</div>
                    </div>
                    {this.state.isEstimate === 0 && (
                    <div className="row">
                      <div className="col-md-6 col-print-6"><label>Invoice Status:</label></div>
                      <div className="col-md-6 col-print-6">{invoiceData && this.checkValidData(invoiceData.status)}</div>
                    </div>)}
                  </div>
                </div>
                <hr />

                {invoiceData && invoiceData.invoice_list_type !== 3 && (
                  <div className="row mb-5">
                    <div className="col-md-6 col-lg-5 col-print-6">
                      <div className="row">
                        <div className="col-md-6 col-print-6"><label>Patient Name:</label></div>
                        <div className="col-md-6 col-print-6">{this.checkValidData(patient_name)}</div>
                      </div>
                      <div className="row">
                        <div className="col-md-6 col-print-6"><label>Patient Email:</label></div>
                        <div className="col-md-6 col-print-6">{this.checkValidData(patient_email)}</div>
                      </div>
                      <div className="row">
                        <div className="col-md-6 col-print-6"><label>Patient Type:</label></div>
                        <div className="col-md-6 col-print-6">{invoiceData && this.checkValidData(invoiceData.patient_type_name)}</div>
                      </div>
                      <div className="row">
                        <div className="col-md-6 col-print-6"><label>Patient Contact:</label></div>
                        <div className="col-md-6 col-print-6">{this.checkValidData(patient_contact)}</div>
                      </div>
                      <div className="row">
                        <div className="col-md-6 col-print-6"><label>Patient Address:</label></div>
                        <div className="col-md-6 col-print-6">
                          <p>{this.checkValidData(patient_address)}</p>
                        </div>
                      </div>
                      {invoiceData && Number(invoiceData.invoice_type_id) === 1 && (
                      <div className="row">
                        <div className="col-md-6 col-print-6"><label>Member Fullname:</label></div>
                        <div className="col-md-6 col-print-6">
                          <p>{patientDetails && patientDetails.member_fullname}</p>
                        </div>
                      </div>)}
                      {invoiceData && Number(invoiceData.invoice_type_id) === 1 && (
                      <div className="row">
                        <div className="col-md-6 col-print-6"><label>Membership Number:</label></div>
                        <div className="col-md-6 col-print-6">
                          <p>{patientDetails && patientDetails.membership_number}</p>
                        </div>
                      </div>)}
                    </div>
                    <div className="col-md-6 col-lg-6 offset-lg-1 col-print-6">
                      {/* <div className="row">
                        <div className="col-md-6 col-print-6"><label>Treating Practitioner:</label></div>
                        <div className="col-md-6 col-print-6">{this.getPractitionerName(invoiceData && invoiceData.requested_related_party_id)}</div>
                      </div> */}
                      <div className="row">
                        <div className="col-md-6 col-print-6"><label>Treatment Start Date & Time:</label></div>
                        <div className="col-md-6 col-print-6">{invoiceData && this.checkValidData(invoiceData.startdatetime)}</div>
                      </div>
                      <div className="row">
                        <div className="col-md-6 col-print-6"><label>Treatment End Date & Time:</label></div>
                        <div className="col-md-6 col-print-6">{invoiceData && this.checkValidData(invoiceData.enddatetime)}</div>
                      </div>
                      <div className="row">
                        <div className="col-md-6 col-print-6"><label>Place of Treatment:</label></div>
                        <div className="col-md-6 col-print-6">{this.checkValidData(invoiceData && invoiceData.place_of_treatment_name)}</div>
                      </div>
                      <div className="row">
                        <div className="col-md-6 col-print-6"><label>Billing Policy:</label></div>
                        <div className="col-md-6 col-print-6">{this.checkValidData(billingPolicyConfiguration && billingPolicyConfiguration.billing_policy)}</div>
                      </div>
                      <div className="row">
                        <div className="col-md-6 col-print-6"><label>Authorization Number:</label></div>
                        <div className="col-md-6 col-print-6 ">{responseData && responseData.authorization_number}</div>
                      </div>
                      <div className="row">
                        <div className="col-md-6 col-print-6"><label>Referring Practitioner:</label></div>
                        <div className="col-md-6 col-print-6">{this.checkValidData(invoiceData && invoiceData.referringPractitionerName)}</div>
                      </div>
                      <div className="row">
                        <div className="col-md-6 col-print-6"><label>Referred To Practitioner:</label></div>
                        <div className="col-md-6 col-print-6">{this.checkValidData(invoiceData && invoiceData.referredToPractitionerName)}</div>
                      </div>
                    </div>
                  </div>)}


                {invoiceData && invoiceData.invoice_list_type === 3 && (
                  <div className="row mb-5">
                    <div className="col-lg-12">
                      <div className={style.billingToWrapper}>
                        <p>Billing To :</p>
                        <p> {bill_to}</p>
                        <p> {invoiceData && invoiceData.billing_email}</p>
                        <p> {billing_address}</p>
                      </div>
                    </div>
                  </div>)}
              </div>
            </div>


            {treatementDetail && treatementDetail.length !== 0 && invoiceData && invoiceData.invoice_list_type !== 3 && (
              <div className="row">
                <div className="col-lg-12">
                  <div
                    className={`table-responsive  ${style.invoiceDetailTable}`}
                  >
                    <table className="table invoice-details-table">
                      <thead>
                        <tr>
                          {/* <th>Date of Service</th> */}
                          <th>Line Item</th>
                          <th>Tariff Code</th>
                          <th>Nappi Code</th>
                          <th className="invoice-desc-col">Description</th>
                          <th>Dia. Code</th>
                          <th>Doc./ Ass. Name</th>
                          <th>Qty.</th>
                          <th>Amount (ZAR)<p style={{ fontSize: "10px", marginBottom: "0px" }}>({invoiceData && invoiceData.vat_percent}% VAT incl.)</p></th>
                        </tr>
                      </thead>
                      <tbody>
                        {treatementDetail && treatementDetail.map((element, index) => (
                          <tr key={index}>
                            {/* <td>{13-02-2020}</td> */}
                            <td>{this.detailFormatter(element.line_type)}</td>
                            <td>{element.tariff_code}</td>
                            <td>{element.nappi_code}</td>
                            <td className="invoice-desc-col">{element.description}</td>
                            <td>{element.diagnosis_code}</td>
                            <td>
                              <span>Dr. {element.doctor_name}</span><br/>
                            <span>{element.billing_practise_pcns_number}</span>
                            </td>
                            <td>{element.quantity}</td>
                            <td>{formatNumberToCurrency(element.price)}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            )}

            {inventory && inventory.length !== 0 && invoiceData && invoiceData.invoice_list_type === 3 && (
              <div className="row">
                <div className="col-lg-12">
                  <div
                    className={`table-responsive  ${style.invoiceDetailTable}`}
                  >
                    <table className="table invoice-details-table">
                      <thead>
                        <tr>
                          <th>Product Name</th>
                          <th>Quantity</th>
                          <th>Unit Price(ZAR)</th>
                          <th>Amount (ZAR)</th>
                        </tr>
                      </thead>
                      <tbody>
                        {inventory &&
                          inventory.map((element, index) => (
                            <tr key={index}>
                              <td>{element.product_name}</td>
                              <td>{element.quantity}</td>
                              <td>{element.unit_price}</td>
                              <td>{formatNumberToCurrency(element.amount)}</td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            )}

            {this.props.invoiceDetailsData.invoiceDetails.invoice &&
              this.props.invoiceDetailsData.invoiceDetails.invoice
                .appointment_reason !== null &&
              this.props.invoiceDetailsData.invoiceDetails.invoice &&
              this.props.invoiceDetailsData.invoiceDetails.invoice
                .description !== null && (
                <div className="row">
                  <div className="col-lg-12">
                    <table width="100%">
                      <tbody>
                        <tr>
                          <td width="50%">
                            <table width="100%">
                              <tbody>
                                <tr>
                                  <td width="30%" style={{ float: "left" }}>
                                    <p>Appointment Reason: </p>
                                  </td>
                                  <td width="70%" style={{ float: "left" }}>
                                    <p>
                                      {this.props.invoiceDetailsData
                                        .invoiceDetails.invoice &&
                                        this.props.invoiceDetailsData
                                          .invoiceDetails.invoice
                                          .appointment_reason
                                        ? this.props.invoiceDetailsData
                                          .invoiceDetails.invoice
                                          .appointment_reason
                                        : "Not Provided"}
                                    </p>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                          <td width="50%">
                            <table width="100%">
                              <tbody>
                                <tr>
                                  <td width="30%" style={{ float: "left" }}>
                                    <p>Description: </p>
                                  </td>
                                  <td width="70%" style={{ float: "left" }}>
                                    <p>
                                      {this.props.invoiceDetailsData
                                        .invoiceDetails.invoice &&
                                        this.props.invoiceDetailsData
                                          .invoiceDetails.invoice.description
                                        ? this.props.invoiceDetailsData
                                          .invoiceDetails.invoice.description
                                        : "Not Provided"}
                                    </p>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

            {/* <div className="row justify-content-end mt-4">
              {this.props.invoiceDetailsData.invoiceDetails &&
                this.props.invoiceDetailsData.invoiceDetails.notes && (
                  <div className="col-lg-6">
                    <p>Note - {notes}</p>
                  </div>
                )}

              <div
                className={` ${
                  this.props.location.state &&
                  this.props.location.state.isFromSupplier
                    ? "col-lg-12"
                    : "col-lg-6"
                }`}
              >
                <div className={`row ${style.totalWrapper}`}>
                  <div
                    className={` ${
                      this.props.location.state &&
                      this.props.location.state.isFromSupplier
                        ? "col-lg-8"
                        : "col-md-6 col-lg-6"
                    }`}
                  >
                    <div className={style.totalAmountWrapper}>
                      <p>Subtotal : </p>
                      <p>VAT ({`${vat_percent} %`}) : </p>
                      <p>Total : </p>
                    </div>
                  </div>
                  <div
                    className={` ${
                      this.props.location.state &&
                      this.props.location.state.isFromSupplier
                        ? "col-lg-3"
                        : "col-md-6 col-lg-6"
                    }`}
                  >
                    <div className={style.totalAmountWrapper}>
                      <p>{sub_total}</p>
                      <p>{vat_amount}</p>
                      <p>{total}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}

            <div className="row">
              <div className="col-md-12">
                <table
                  className={`table table-borderless ${style.totalTableWrapper}`}
                >
                  <tbody>
                    <tr>
                      <td width="50%">
                        {this.props.invoiceDetailsData.invoiceDetails &&
                          this.props.invoiceDetailsData.invoiceDetails
                            .notes && (
                            <div className="col-lg-6">
                              <p>Note - {notes}</p>
                            </div>
                          )}
                      </td>
                      <td width="50%" style={{ float: "right", minWidth: "400px" }}>
                        {invoiceData && invoiceData.invoice_list_type === 3 && (
                          <table className={"invoice-subtotal"}>
                            <tbody>
                              <tr>
                                <th>Subtotal:</th>
                                <td className="text-right">{formatNumberToCurrency(sub_total)}</td>
                              </tr>
                              <tr>
                                <th>VAT ({`${vat_percent}%`}):</th>
                                <td className="text-right">{formatNumberToCurrency(vat_amount)}</td>
                              </tr>
                              <tr>
                                <th>Total:</th>
                                <td className="text-right">{formatNumberToCurrency(total)}</td>
                              </tr>
                            </tbody>
                          </table>)}

                        {invoiceData && invoiceData.invoice_list_type !== 3 && (
                          <React.Fragment>
                            <div className="row"><div className="col-md-8 text-right col-print-8"><label>Total {this.state.isEstimate === 0 ? "invoice" : "estimate"} (ZAR):</label>
                            </div><div className="col-md-4 pr-4 text-right col-print-4">{formatNumberToCurrency(total)}</div></div>
                           {this.state.isEstimate === 0 && ( 
                             <React.Fragment>
                             {invoiceData && invoiceData.invoice_type_id && Number(invoiceData.invoice_type_id) === 1 && (<div className="row">
                              <div className="col-md-8 text-right col-print-8"><label>Claimed amount (ZAR):</label></div>
                            <div className="col-md-4 pr-4 text-right col-print-4">{invoiceData && formatNumberToCurrency(invoiceData.claimed_amount)}</div></div>)}
                            {invoiceData && invoiceData.invoice_type_id && Number(invoiceData.invoice_type_id) === 1 && (<div className="row">
                              <div className="col-md-8 text-right col-print-8"><label>Patient liable amount (ZAR):</label></div>
                            <div className="col-md-4 pr-4 text-right col-print-4">{invoiceData && formatNumberToCurrency(invoiceData.patient_liable_amount)}</div></div>)}
                            {invoiceData && invoiceData.invoice_type_id && Number(invoiceData.invoice_type_id) === 1 && (<div className="row">
                              <div className="col-md-8 text-right col-print-8"><label>Scheme liable amount (ZAR):</label></div>
                            <div className="col-md-4 pr-4 text-right col-print-4">{invoiceData && formatNumberToCurrency(invoiceData.scheme_liable_amount)}</div></div>)}
                            <div className="row"><div className="col-md-8 text-right col-print-8"><label>Discount Amount(ZAR):</label></div>
                            <div className="col-md-4 pr-4 text-right col-print-4">{invoiceData && formatNumberToCurrency(getValueOfPercent(invoiceData.total,invoiceData.discount))}</div></div>
                            <div className="row"><div className="col-md-8 text-right col-print-8"><label>Write Off Amount(ZAR):</label></div>
                            <div className="col-md-4 pr-4 text-right col-print-4">{invoiceData && formatNumberToCurrency(invoiceData.writeoff_amount)}</div></div>          
                            <div className="row"><div className="col-md-8 text-right col-print-8"><label>Amount paid (ZAR):</label></div>
                            <div className="col-md-4 pr-4 text-right col-print-4">{invoiceData && formatNumberToCurrency(invoiceData.amount_paid)}</div></div>
                            <div className="row"><div className="col-md-8 text-right col-print-8"><label>Balance pay (ZAR):</label></div>
                            <div className="col-md-4 pr-4 text-right col-print-4">{invoiceData && formatNumberToCurrency(invoiceData.balance)}</div></div>
                            </React.Fragment>
                            )}
                          </React.Fragment>
                        )}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-12"></div>
            </div>
            {invoiceData && Number(invoiceData.invoice_list_type) !== 3 && (
                <div className="row">
                  <div className="col-lg-12 text-center">
                    <p>Thank You</p>
                    <p>For questions concerning this {this.state.isEstimate === 0 ? "invoice" : "estimate"}, please contact</p>
                    <p className={style.contactInfo}>
                      <span>{billingPractitionerDetails && billingPractitionerDetails.registration_name}</span>
                      <span>Ph no. : {billingPractitionerDetails && billingPractitionerDetails.contact_number}</span>
                      <span>Email : {billingPractitionerDetails && billingPractitionerDetails.email}</span>
                    </p>
                  </div>
                </div>
              )}

              <div className="row">
                <div class="logo-footer d-print-block d-none col-md-12">
                  <div class="print-logo text-center">
                    <p>Powered By:</p>
                    <img src={techtToMed} class="print-ttm-logo" alt="TechToMed" />
                  </div>
                </div>
              </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            {this.state.isLoading ? (
              <div className={style.loadingWrapper}>
                <img src={ttmLoader} alt="loader" className={style.loading} />
              </div>
            ) : (
                <div>
                  {this.state.successMessage && (
                    <p className={style.successMessage}>
                      {this.state.successMessage}
                    </p>
                  )}
                  {this.state.errorMessage && (
                    <p className={style.errorMessage}>
                      {this.state.errorMessage}
                    </p>
                  )}
                </div>
              )}
          </div>
        </div>
        <div className="row">
          <div className={`col-lg-12 ${style.invoiceDetailsBtnWrapper}`}>
            <div>
              {/* <Button className="form-primary-btn">Cancel</Button> */}
            </div>
            <div>
              {invoiceData && invoiceData.appointment_id && (
                <Button
                  type="button"
                  className="form-primary-btn mr-4 mt-2"
                  onClick={() => this.goToAppointment(invoiceData.appointment_id)}
                >
                  Go To Appointment
                </Button>
              )}
              
              {invoiceData && invoiceData.appointment_id && invoiceData.isEstimate === 0 && 
              Math.sign(Number(invoiceData.balance)) === -1 && (
                  <Button
                      className="ttm-primary-btn mr-4 mt-2"
                      type="button"
                      onClick={this.makePayment}
                  >
                      Make Payment
                  </Button>)}
              {invoiceData && invoiceData.appointment_id && invoiceData.isEstimate === 0 && 
              Math.sign(Number(invoiceData.balance)) === 1 && (
                <Button
                  type="button"
                  className="form-primary-btn mr-4 mt-2"
                  onClick={() => this.recievePayment()}
                >
                  Receive Payment
                </Button>
              )}
              {checkIfPermitted(Permissions.PRINT_SEND_INVOICES) && (
                <Button
                  type="button"
                  className="form-primary-btn mr-4 mt-2"
                  onClick={this.DownloadInvoice}
                >
                  Download
                </Button>
              )}
              {checkIfPermitted(Permissions.PRINT_SEND_INVOICES) && (
                <Button
                  type="button"
                  className="form-primary-btn mr-4 mt-2"
                  onClick={this.toggle}
                >
                  Share Via Email
                </Button>
              )}
              {/* <Button type="button" className="form-primary-btn" >
                Print Invoice
              </Button> */}
              {checkIfPermitted(Permissions.PRINT_SEND_INVOICES) && (
                <ReactToPrint
                  trigger={() => (
                    <Button type="button" className="form-primary-btn mt-2">
                      Print
                    </Button>
                  )}
                  content={() => this.componentInvoiceRef}
                />)}
            </div>
          </div>
        </div>
        <Modal
                            isOpen={this.state.isModalOpen}
                            toggle={this.toggle}
                            className={style.deleteReason}
                            centered
                        >
                            <ModalHeader
                                toggle={this.toggle}
                                className={style.deleteReasonHeader}
                            >
                                Share Via Email
            </ModalHeader>
                            <ModalBody>
                                <Formik
                                    initialValues={this.state}
                                    enableReinitialize={true}
                                    validationSchema={Yup.object().shape({
                                        shareEmail: Yup.string().required("Email is required")
                                            .matches(/^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/, "Enter valid email"),
                                    })}
                                    onSubmit={this.shareViaEmail}
                                >
                                    {({ errors, status, touched }) => (
                                        <Form>
                                            <div className={style.deleteReasonHeadingWrapper}>
                                                <p>
                                                    Please enter email{" "}
                                                </p>
                                            </div>
                                            <div className={style.deleteReasonFormWrapper}>
                                                <div className="form-group">
                                                    <Field
                                                        name="shareEmail"
                                                        placeholder="Enter Email"
                                                        className={
                                                            "form-control" +
                                                            (errors.shareEmail && touched.shareEmail
                                                                ? " is-invalid"
                                                                : "")
                                                        }
                                                        onChange={this.handleChange}
                                                        value={this.state.shareEmail}

                                                    >
                                                    </Field>
                                                    <ErrorMessage
                                                        name="shareEmail"
                                                        component="div"
                                                        className="invalid-feedback"
                                                    />

                                                </div>
                                                <div className={`row ${style.deleteBtnWrapper}`}>
                                                    <div className="col-lg-12">
                                                        <div>
                                                            <button
                                                                type="submit"
                                                                disabled={this.state.successMessage}
                                                                className={`mr-4 ${style.deleteBtn}`}
                                                            >
                                                                Proceed
                        </button>
                                                            <button
                                                                type="button"
                                                                disabled={this.state.successMessage}
                                                                className={style.cancelBtn}
                                                                onClick={this.toggle}
                                                            >
                                                                Cancel
                        </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Form>
                                    )}

                                </Formik>
                            </ModalBody>
                        </Modal>
      </div>
    );
  }
}

// export default InvoiceDetails;

const mapStateToProps = (state) => {
  return {
    invoiceDetailsData: state.invoiceDetails,
    practitionerData: state.practitioner,
    dropdownListData: state.dropdownList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchInvoiceDetails: (invoice_id) =>
      dispatch(fetchInvoiceDetails(invoice_id)),
    fetchpractitioner: (practitionerName) =>
      dispatch(fetchpractitioner(practitionerName)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceDetails);
